// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"d950e483","138":"e2e89617","270":"dd666a81","387":"4d61303c","404":"7dae82bf","488":"b2a64b34","545":"d2dc63cc","580":"b9d15e65","686":"fbd6ccf8","706":"44ba4c26","728":"588dcaa8","801":"f250965f","888":"46548a16"}[chunkId] + ".chunk.js";
};